import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Table from "../../../core/pagination/datatable";
import { getSalesByTransType } from "../../../services/SalesApiServices";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import dayjs from "dayjs";
import moment from "moment";

const SalesReport1Delivery = ({ data, Reportcolumns,summary ,pagination}) => {
  const [searchText, setSearchText] = useState("");
  const [salesData, setsalesData] = useState([]);
  const [filteredSalesData, setfilteredSalesData] = useState([]);
  const { branch } = useSelector((state) => state.branchlist);

  const MySwal = withReactContent(Swal);

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  useEffect(() => {
    handlesalesData();
  }, [branch]);

  const handlesalesData = async () => {
    try {
      const response = await getSalesByTransType(branch, 1);
      setsalesData(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error(
        "Failed to fetch sales invoices",
        error?.response?.data?.Message || "something went wrong"
      );
      MySwal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch sales data.",
      });
    }
  };

  const showConfirmationAlert = () => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };

  return (
    <div>
      <Table columns={Reportcolumns} dataSource={data}
      summary={summary}
      pagination={pagination}
      />
    </div>
  );
};

export default SalesReport1Delivery;
